export default __webpack_public_path__ + "static/media/TOASTER MESSAGES.c97e5283.png";